import React from 'react'
import { Box } from '@mui/material'
import SignInBg from 'assets/bg/signin.jpg'
import SignUpBg from 'assets/bg/signup.jpg'
import LoggedOutControls from 'components/Auth/LoggedOutControls'
import { getDeviceInformation } from 'utils/helper'

const sx = {
  root: {
    backgroundColor: '#fff',
    minHeight: '100vh',
    display: 'flex',
    flex: 1,
  },
  infoSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40%',
    backgroundSize: 'cover',
    [theme => theme.breakpoints.down(813)]: {
      display: 'none',
    },
  },
  formSection: {
    width: '61%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgb(248, 250, 251)',
    paddingTop: theme => theme.spacing(9.5),
    [theme => theme.breakpoints.down(813)]: {
      width: '100%',
      padding: '0 50px',
    },
  },
  infoText: {
    textAlign: 'center',
    position: 'fixed',
    top: '50%',
  },
}

const AuthLayout = ({ children, bgType, noAuthHeader, controls }) => {
  const styleWithBackgroudImage = {
    backgroundImage: `url(${bgType === 'signIn' ? SignInBg : SignUpBg})`,
  }

  const isAndroid = getDeviceInformation(window).includes('Android')
  const isIphone = getDeviceInformation(window).includes('iPhone')
  const isIpad = getDeviceInformation(window).includes('iPad')
  const isMobile = isAndroid || isIphone || isIpad

  return (
    <>
      {!isMobile && (
        <Box sx={sx.root}>
          {!noAuthHeader && <LoggedOutControls controls={controls} />}
          <Box sx={sx.infoSection} style={styleWithBackgroudImage}>
            <Box display="flex" height="100%" alignItems="center" justifyContent="center" flexDirection="column">
              <Box textAlign="center" fontWeight={600} fontSize="22px" color="#fff">
                Unleash your business’s growth potential
              </Box>
              <Box textAlign="center" fontSize="16px" color="#fff" margin="20px">
                Get all the services you need to manage your finances, assess your creditworthiness, get fast financing,
                and easily apply for the services you need to grow.
              </Box>
            </Box>
          </Box>
          <Box sx={sx.formSection}>{children}</Box>
        </Box>
      )}
    </>
  )
}

export default AuthLayout
